import { defineMessages } from 'react-intl';

export default defineMessages({
	infoFormEmailError: {
		id: 'teams.info.form.emailError',
		defaultMessage: 'Your work email is required',
		description: 'Error when validation fails for the email field on the info form.',
	},
	infoFormFirstNameError: {
		id: 'teams.info.form.firstNameError',
		defaultMessage: 'Your first name is required',
		description: 'Error when validation fails for the first name field on the info form.',
	},
	infoFormLastNameError: {
		id: 'teams.info.form.lastNameError',
		defaultMessage: 'Your last name is required',
		description: 'Error when validation fails for the last name field on the info form.',
	},
	infoFormEmailLabel: {
		id: 'teams.info.form.emailLabel',
		defaultMessage: 'Work Email (Required)',
		description: 'Label for the form input field.',
	},
	infoFormFirstNameLabel: {
		id: 'teams.info.form.firstNameLabel',
		defaultMessage: 'First Name (Required)',
		description: 'Label for the form input field.',
	},
	infoFormLastNameLabel: {
		id: 'teams.info.form.lastNameLabel',
		defaultMessage: 'Last Name (Required)',
		description: 'Label for the form input field.',
	},
	infoFormCtaCopy: {
		id: 'teams.info.form.cta.copy',
		defaultMessage: 'Continue',
		description: 'Cta button for info form.',
	},
	infoFormErrorBanner: {
		id: 'teams.info.form.errorBanner',
		defaultMessage: 'There {errorCount} that require your attention',
		description: 'Error banner for the form.',
	},
	infoFormTermsAndPrivacyPolicy: {
		id: 'teams.info.form.termsAndPrivacyPolicy',
		defaultMessage:
			"By clicking 'Continue', you agree to our {terms} and acknowledge that you have read our <privacypolicylink>Privacy Policy</privacypolicylink>",
		description: 'Description for terms and privacy policy on info form.',
	},
	terms: {
		id: 'teams.info.form.terms',
		defaultMessage: 'Terms',
		description: 'the word "terms"',
	},
});
